import React, { FC } from 'react'

import { Button, Icon } from '@madup-inc/mad-design'

import Table from './../Table'
import { contextTable } from '../../constants/table'
import useModalForm from '../../hooks/context/useModalForm'
import ModalForm from '../Modal/ModalForm'
import context from '../../constants/form/context'

const Context: FC = () => {
  const { isVisible, setIsVisible, fields, onClickCreate } = useModalForm(contextTable.path)

  return (
    <>
      <div
        style={{
          marginBottom: '24px',
          textAlign: 'right',
        }}
      >
        <Button
          type="dashed"
          ghost
          onClick={() => {
            setIsVisible(true)
          }}
        >
          <Icon type="add" />
          Create
        </Button>
      </div>
      <Table table={contextTable} />
      <ModalForm
        form={context}
        visible={isVisible}
        handleOK={() => {
          onClickCreate()
        }}
        handleCancel={() => {
          setIsVisible(false)
        }}
        fields={fields}
        title="Create Context"
        okText="Create"
      />
    </>
  )
}

export default Context
